import Vue from 'vue';
import ECharts from 'vue-echarts';

import theme from './theme.json';
import themeSecondary from './theme-secondary.json';
import primarydark from './theme-dark.json';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';

ECharts.registerTheme('primary', theme);
ECharts.registerTheme('secondary', themeSecondary);
ECharts.registerTheme('primarydark', primarydark);

Vue.component('v-chart', ECharts);
